import { call, put, takeLatest, select, takeEvery } from 'redux-saga/effects';
import * as apis from '@/apis/checkout';
import * as actions from '@/actions/checkout';
import {
  GET_DELIVERY_SLOTS,
  GET_ADDRESS_BY_POSTALCODE,
  GET_DELIVERY_ADDRESS_LIST,
  UPDATE_DELIVERY_ADDRESS,
  DELETE_DELIVERY_ADDRESS,
  GET_PAYMENT_TYPES,
  GET_BILLING_ADDRESS_LIST,
  GET_POPSTATION_LIST,
  GET_POPSTATION_ADDRESS_BY_POSTALCODE,
  GET_ALL_DELIVERY_CHARGES_REQUEST,
  GET_SPLIT_PAYMENT_TYPE_REQUEST,
  CHECK_CUSTOMER_CODE_ELIGIBILITY_REQUEST,
  GET_BILLING_ADDRESS_LIST_SERVICE_NO,
  GET_PORT_IN_DATE_LIST
} from '@/actions/checkout';

import {
  IgetAddressByPostalCode,
  IupdateDeliveryAddress,
  IdeleteDeliveryAddress,
  IgetPOPStationAddressByPostalCode,
  Ierror,
  ICheckCustCodeEligibility,
  UploadMultiLineESimFileRequest,
  DownloadMultilineReceipientsESimRequest
} from '@/actions/checkout/model/type';
import { getDeliveryCharges } from '@/helpers/order';
import {
  DOWNLOAD_MULTILINE_RECEIPIENTS_ESIM_REQUEST,
  GET_ESIM_CARD_PROFILE_TYPE,
  PDPA_DELETE_EXIST_RESADDR_REQUEST,
  PDPA_RETREIVE_RESADDRESS_REQUEST,
  PDPA_SAVE_NEW_RESADDR_REQUEST,
  PDPA_UPDATE_EXIST_RESADDR_REQUEST,
  UPLOAD_MULTILINE_RECEIPIENTS_ESIM_REQUEST

} from '@/actions/checkout/actionTypes';

export const getAuth = (state) => state.auth;
export const getOrder = (state) => state.order.currentOrder;

function* getDeliverySlots() {
  try {
    const result = yield call(apis.getDeliverySlots);
    yield put(actions.getDeliverySlots.success(result.data));
  } catch (error) {
    yield put(actions.getDeliverySlots.failure(error));
  }
}

function* getAddressByPostalCode({ postalCode, callback }: IgetAddressByPostalCode) {
  try {
    const result = yield call(apis.getAddressByPostalCode, postalCode);
    yield call(callback, null, result.data);
  } catch (error) {
    yield call(callback, error, null);
  }
}

function* getDeliveryAddressList() {
  try {
    const auth = yield select(getAuth);
    const { brn } = auth.currentAccount;
    const result = yield call(apis.getDeliveryAddressList, brn);
    const deliveryAddressList = [...result.data];
    yield put(actions.getDeliveryAddressList.success(deliveryAddressList));
  } catch (error) {
    yield put(actions.getDeliveryAddressList.failure(error));
  }
}

function* updateDeliveryAddress({ address }: IupdateDeliveryAddress) {
  try {
    const auth = yield select(getAuth);
    const brn = auth.currentAccount.brn;
    const result = yield call(apis.updateDeliveryAddress, {
      ...address,
      brn
    });
    yield put(actions.updateDeliveryAddress.success(result.data));
    yield put(actions.getDeliveryAddressList.request());
  } catch (error) {
    yield put(actions.updateDeliveryAddress.failure(error));
  }
}

function* deleteDeliveryAddress({ address }: IdeleteDeliveryAddress) {
  try {
    const auth = yield select(getAuth);
    const brn = auth.currentAccount.brn;
    const result = yield call(apis.deleteDeliveryAddress, {
      ...address,
      brn
    });
    yield put(actions.deleteDeliveryAddress.success(result.data));
    yield put(actions.getDeliveryAddressList.request());
  } catch (error) {
    yield put(actions.deleteDeliveryAddress.failure(error));
  }
}

function* getPaymentTypes() {
  try {
    const {
      currentAccount: { msaheaderId, brn }
    } = yield select(getAuth);
    const { shoppingCartType } = yield select(getOrder);
    const result = yield call(apis.getPaymentTypes, brn, shoppingCartType, msaheaderId);
    yield put(actions.getPaymentTypes.success(result.data));
    const customerIds = yield call(apis.getCustomerIds, brn);
    yield put(actions.getCustomerIds.success(customerIds.data));
  } catch (error) {
    yield put(actions.getPaymentTypes.failure(error));
  }
}

function* getBillingAddressList(reqData) {
  try {
    const result = yield call(apis.getBillingAddressList, reqData.reqData);
    yield put(actions.getBillingAddressList.success(result.data));
  } catch (error) {
    yield put(actions.getBillingAddressList.failure(error));
  }
}

function* getBillingAddressListServiceNo() {
  try {
    const auth = yield select(getAuth);
    const brn = auth.currentAccount.brn;
    const { cartDetails } = yield select(getOrder);
    const serviceNumbers = cartDetails.serviceNumbers.map((item) => item.number);
    const result = yield call(apis.getBillingAddressListServiceNo, brn, serviceNumbers);
    yield put(actions.getBillingAddressListServiceNo.success(result.data));
  } catch (error) {
    yield put(actions.getBillingAddressListServiceNo.failure(error));
  }
}

function* getPOPStationList() {
  try {
    const result = yield call(apis.getPOPStationList);
    yield put(actions.getPOPStationList.success(result.data));
  } catch (error) {
    yield put(actions.getPOPStationList.failure(error));
  }
}

function* getPOPStationAddressByPostalCode({ postalCode, callback }: IgetPOPStationAddressByPostalCode) {
  try {
    const result = yield call(apis.getPOPStationAddress, postalCode);
    yield call(callback, result.data);
  } catch (error) {
    const err = error as Ierror;
    yield call(callback, null, err?.message);
  }
}

function* getAllDeliveryChargeType() {
  try {
    const {
      currentAccount: { msaheaderId }
    } = yield select(getAuth);
    const result = yield call(apis.getAllDeliveryCharges, msaheaderId);
    const charges = getDeliveryCharges(result.data);
    yield put(actions.getAllDeliveryCharges.success(charges));
  } catch (error) {
    yield put(actions.getAllDeliveryCharges.failure(error));
  }
}

function* getSplitPaymentType(brn) {
  try {
    const result = yield call(apis.getSplitPaymentType, brn.brn);
    yield put(actions.getAllowSplitPaymentType.success(result.data));
  } catch (error) {
    yield put(actions.getAllowSplitPaymentType.failure(error));
  }
}

function* pdpaRetreiveResidentialAddress() {
  try {
    const auth = yield select(getAuth);
    const brn = auth.currentAccount.brn;
    const result = yield call(apis.pdpaRetreiveResidentialAddress, brn);
    yield put(actions.pdpaRetreiveResidentialAddress.success(result.data));
  } catch (error) {
    yield put(actions.pdpaRetreiveResidentialAddress.failure(error));
  }
}
function* pdpaSaveNewResAddress({ address }: IdeleteDeliveryAddress) {
  try {
    const auth = yield select(getAuth);
    const brn = auth.currentAccount.brn;
    const { postalCode, houseBlockNumber, streetName, buildingName, unitNumber } = address;
    const savePayload = {
      recpFirstName: address.name,
      recpLastName: '',
      recpEmail: address.email,
      recpMobileNo: address.mobile,
      postalCode,
      houseBlockNumber,
      streetName,
      buildingName,
      unitNumber
    };
    const result = yield call(apis.pdpaSaveNewResAddress, {
      ...savePayload,
      brn
    });

    yield put(actions.pdpaSaveNewResAddress.success(result.data));
    yield put(actions.pdpaRetreiveResidentialAddress.request());
  } catch (error) {
    yield put(actions.pdpaSaveNewResAddress.failure(error));
  }
}

function* pdpaUpdateExistResAddress({ address }: IupdateDeliveryAddress) {
  try {
    const auth = yield select(getAuth);
    const { postalCode, houseBlockNumber, streetName, buildingName, unitNumber } = address;
    const savePayload = {
      ...address,
      recpFirstName: address.name,
      recpLastName: '',
      recpEmail: address.email,
      recpMobileNo: address.mobile,
      postalCode,
      houseBlockNumber,
      streetName,
      buildingName,
      unitNumber
    };
    const brn = auth.currentAccount.brn;
    const result = yield call(apis.pdpaUpdateExistResAddress, {
      ...savePayload,
      brn
    });
    yield put(actions.pdpaUpdateExistResAddress.success(result.data));
    yield put(actions.pdpaRetreiveResidentialAddress.request());
  } catch (error) {
    yield put(actions.pdpaUpdateExistResAddress.failure(error));
  }
}

function* pdpaDeleteExistResAddress({ address }: IdeleteDeliveryAddress) {
  try {
    const auth = yield select(getAuth);
    const brn = auth.currentAccount.brn;
    const result = yield call(apis.pdpaDeleteExistResAddress, {
      ...address,
      brn
    });
    yield put(actions.pdpaDeleteExistResAddress.success(result.data));
    yield put(actions.pdpaRetreiveResidentialAddress.request());
  } catch (error) {
    yield put(actions.pdpaDeleteExistResAddress.failure(error));
  }
}

function* checkCustomerCodeEligibility({ payload }: ICheckCustCodeEligibility) {
  try {
    const result = yield call(apis.checkCustCodeEligibility, payload);
    yield put(actions.checkCustCodeEligibility.success(result.data));
  } catch (error) {
    yield put(actions.checkCustCodeEligibility.failure(error));
  }
}

function* getPortInDatesList(payload) {
  try {
    const result = yield call(apis.getPortInDatesList, payload.payload);
    const deliveryAddressList = [...result.data];
    yield put(actions.getPortInDatesList.success(deliveryAddressList));
  } catch (error) {
    yield put(actions.getPortInDatesList.failure(error));
  }
}

function* getESimCardProfileType(payload) {
  try {
    const result = yield call(apis.getESimCardProfileType, payload.payload);
    yield put(actions.getESimCardProfileType.success(result.data));
  } catch (error) {
    yield put(actions.getESimCardProfileType.failure(error));
  }
}
function* uploadMultilineReceipientsESim({ fileData, cartId }: UploadMultiLineESimFileRequest) {
  try {
    const formData = new FormData();

    [...fileData].forEach(file => {
      formData.append("files", file);
    });

    const result = yield call(apis.uploadMultilineReceipientsESim, formData, cartId);
    yield put(actions.uploadMultilineReceipientsESim.success(result.data));
  } catch (error) {
    yield put(actions.uploadMultilineReceipientsESim.failure(error));
  }
}

function* downloadMultilineReceipientsESim({ cartId }: DownloadMultilineReceipientsESimRequest) {
  try {
    const result = yield call(apis.downloadMultilineReceipientsESim, cartId);
    if (result.data) {
      const url = window.URL.createObjectURL(new Blob([result.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `recipient.csv`);
      document.body.appendChild(link);
      link.click();
    } else {
      yield put(actions.downloadMultilineReceipientsESim.failure({}));
    }
    yield put(actions.downloadMultilineReceipientsESim.success(result.data));
  } catch (error) {
    yield put(actions.downloadMultilineReceipientsESim.failure(error));
  }
}

export default function* checkoutSagas() {
  yield takeLatest(GET_DELIVERY_SLOTS, getDeliverySlots);
  yield takeLatest(GET_ADDRESS_BY_POSTALCODE, getAddressByPostalCode);
  yield takeLatest(GET_DELIVERY_ADDRESS_LIST, getDeliveryAddressList);
  yield takeLatest(UPDATE_DELIVERY_ADDRESS, updateDeliveryAddress);
  yield takeEvery(DELETE_DELIVERY_ADDRESS, deleteDeliveryAddress);
  yield takeLatest(GET_PAYMENT_TYPES, getPaymentTypes);
  yield takeLatest(GET_BILLING_ADDRESS_LIST, getBillingAddressList);
  yield takeLatest(GET_BILLING_ADDRESS_LIST_SERVICE_NO, getBillingAddressListServiceNo);
  yield takeLatest(GET_POPSTATION_LIST, getPOPStationList);
  yield takeLatest(GET_POPSTATION_ADDRESS_BY_POSTALCODE, getPOPStationAddressByPostalCode);
  yield takeLatest(GET_ALL_DELIVERY_CHARGES_REQUEST, getAllDeliveryChargeType);
  yield takeLatest(GET_SPLIT_PAYMENT_TYPE_REQUEST, getSplitPaymentType);
  yield takeLatest(PDPA_RETREIVE_RESADDRESS_REQUEST, pdpaRetreiveResidentialAddress);
  yield takeLatest(PDPA_DELETE_EXIST_RESADDR_REQUEST, pdpaDeleteExistResAddress);
  yield takeEvery(PDPA_UPDATE_EXIST_RESADDR_REQUEST, pdpaUpdateExistResAddress);
  yield takeLatest(PDPA_SAVE_NEW_RESADDR_REQUEST, pdpaSaveNewResAddress);
  yield takeLatest(CHECK_CUSTOMER_CODE_ELIGIBILITY_REQUEST, checkCustomerCodeEligibility);
  yield takeLatest(GET_PORT_IN_DATE_LIST, getPortInDatesList);
  yield takeLatest(GET_ESIM_CARD_PROFILE_TYPE, getESimCardProfileType);
  yield takeLatest(UPLOAD_MULTILINE_RECEIPIENTS_ESIM_REQUEST, uploadMultilineReceipientsESim);
  yield takeLatest(DOWNLOAD_MULTILINE_RECEIPIENTS_ESIM_REQUEST, downloadMultilineReceipientsESim);
}
